<template>
  <div>
    <ModalCreate
      ref="modalCreate"
      :wip="wip"
      :submitting="submitting"
      @form-data-changed="setWip"
      @form-data-submit="doSubmit"
    />
  </div>
</template>

<script>
import ModalCreate from '@/components/PackageEdition/ModalCreate.vue';
import { packageEditionMethods, packageEditionComputed } from '@/store/adminHelper';
import { HTTP_UNPROCESSABLE_ENTITY } from '@/api/http-response-codes';
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';

export default {
  name: 'PackageEditionCreate',
  mixins: [veeValidateErrorsMixin],
  components: {
    ModalCreate,
  },
  props: {
    packageId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    submitting: false,
  }),
  computed: {
    ...packageEditionComputed,
  },
  created() {
    const { packageId } = this;
    this.setWip({ packageId });
  },
  destroyed() {
    this.clearWip();
  },
  methods: {
    ...packageEditionMethods,
    doSubmit(next) {
      const { packageId, wip: postData } = this;
      this.submitting = true;
      this.storePackageEdition({ packageId, postData })
        .then(() => {
          this.submitting = false;
          next();
        })
        .catch(({ status = null, data = {} } = {}) => {
          if (status === HTTP_UNPROCESSABLE_ENTITY) {
            this.observer = this.$refs.modalCreate.$refs.observer;
            this.addServerErrors(data.errors);
          }
          this.submitting = false;
        });
    },
  },
};
</script>
